import React from 'react';
import './PersonRail.css';

/**
 * Left-hand "jump to" rail. Purely presentational — MeetingDetail owns the
 * scroll-spy that decides which entry is current, so this stays trivial to
 * test with plain props.
 */
export default function PersonRail({ people, current, showMarketing = false, marketingActive = false }) {
  if (!people || !people.length) return null;

  return (
    <nav className="ml-rail" aria-label="Jump to meeting section">
      <h4 className="ml-rail-h">Jump to</h4>
      {people.map((p, i) => (
        <a
          key={p.id}
          href={`#${p.anchorId}`}
          className={`ml-rail-link${!marketingActive && i === current ? ' on' : ''}`}
          style={{ '--tone': p.tone }}
          data-testid="rail-link"
        >
          <span className="ml-rail-dot">{p.initials}</span>
          <span className="ml-rail-name">{p.name}</span>
        </a>
      ))}
      {showMarketing && (
        <a
          href="#meeting-marketing"
          className={`ml-rail-link ml-rail-marketing${marketingActive ? ' on' : ''}`}
          style={{ '--tone': 'var(--rmc-blue)' }}
          data-testid="marketing-rail-link"
          aria-label="Jump to Marketing Report"
        >
          <span className="ml-rail-dot">MK</span>
          <span className="ml-rail-name">Marketing</span>
        </a>
      )}
    </nav>
  );
}
